import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardFooter,
  Typography,
  Drawer,
} from "@material-tailwind/react";
import { DataGrid } from "@mui/x-data-grid";
import { IoClose } from "react-icons/io5";

import { useUserContext } from "../../contexts/UserContextProvider";
import { useApplicationIntegrationContext } from "../../contexts/ApplicationIntegrationContextProvider";

import { SeoTags } from "..";

const AppIntegrationManager = () => {
  const { currentUserInfo } = useUserContext();
  const { registerOnBigin, getChatbotBiginLeadFlows } =
    useApplicationIntegrationContext();

  const [biginFlowData, setBiginFlowData] = useState([]);
  const [biginDGRowData, setBiginDGRowData] = useState([]);
  const [openBiginIntegrationFlow, setBiginIntegrationFlowOpen] =
    useState(false);

  const openChatbotBiginFlowsDrawer = () => {
    const rows = biginFlowData.map((row, index) => ({
      id: index,
      ...row,
    }));
    setBiginDGRowData(rows);
    setBiginIntegrationFlowOpen(true);
  };
  const closeChatbotBiginFlowsDrawer = () => setBiginIntegrationFlowOpen(false);

  const columns = [
    { field: "Description", headerName: "Description", flex: 2 },
    { field: "pipeLine", headerName: "Pipeline", flex: 1 },
    { field: "subPipeline", headerName: "Sub Pipeline", flex: 1 },
    { field: "stage", headerName: "Stage", flex: 1 },
    { field: "leadSource", headerName: "Lead Source", flex: 1 },
  ];

  const loadChatbotBiginLeadFlow = async () => {
    try {
      const result = await getChatbotBiginLeadFlows();
      if (result?.[0]) {
        setBiginFlowData(Object.values(result[0]));
      } else {
        setBiginFlowData([]);
      }
    } catch (error) {
      console.error("Error loading Bigin integration flow:", error);
      setBiginFlowData([]);
    }
  };

  useEffect(() => {
    if (currentUserInfo?.isBiginIntegrated) {
      loadChatbotBiginLeadFlow();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main className="w-full mt-5 mb-10 lg:my-1 space-y-5">
      <SeoTags title="Integrations ‣ WaBM" />

      <div className="w-full space-y-2">
        <h1 className="text-2xl">App Integrations Manager</h1>
        <h3>
          Following are the options to manage third party app integrations
        </h3>
        <p className="mt-5 text-sm text-blue-600"></p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
        <Card>
          <CardBody>
            <Typography variant="h5" color="blue-gray" className="mb-2">
              Zoho Bigin (Beta)
            </Typography>
            <Typography>
              Attach your Bigin profile to start the automation
            </Typography>
          </CardBody>
          <CardFooter className="pt-0 flex flex-row gap-2">
            <button
              type="button"
              disabled={currentUserInfo?.isBiginIntegrated}
              onClick={() => registerOnBigin()}
              className="my-button-style-1 mt-3"
            >
              Register Bigin App
            </button>
            <button
              type="button"
              disabled={!currentUserInfo?.isBiginIntegrated}
              onClick={openChatbotBiginFlowsDrawer}
              className="my-button-style-1 bg-green-700 mt-3 hover:text-yellow-300"
            >
              Bigin Flow
            </button>
          </CardFooter>
        </Card>
      </div>

      <Drawer
        open={openBiginIntegrationFlow}
        onClose={closeChatbotBiginFlowsDrawer}
        placement="bottom"
        size={700}
      >
        <Card className="h-full">
          <CardBody>
            <div className="flex justify-between items-center mb-4">
              <Typography variant="h5" color="blue-gray">
                Chatbot-Bigin Flow
              </Typography>
              <button
                onClick={closeChatbotBiginFlowsDrawer}
                className="my-button-style-cancel right-5"
              >
                <IoClose size={18} />
              </button>
            </div>

            <div style={{ height: "80vh", width: "100%" }}>
              <DataGrid rows={biginDGRowData} columns={columns} />
            </div>
          </CardBody>
        </Card>
      </Drawer>
    </main>
  );
};

export default AppIntegrationManager;
